// extracted by mini-css-extract-plugin
module.exports = {"adListItem":"ad-slot-list_adListItem__RLEE6","adOuter":"ad-slot-list_adOuter__KC17M","adInner":"ad-slot-list_adInner__kW7H_"};